import React from 'react';
import { DropdownPricingButton } from './DropdownPricingButton';
import { PricingContent } from './PricingContent';

type Props = {
  noHover?: boolean;
};

export const NavPrivatePricing: React.FC<Props> = ({ noHover = true }) => (
  <DropdownPricingButton noHover={noHover}>
    <PricingContent />
  </DropdownPricingButton>
);
